/**
 * EcosystemSection Component
 * ==========================
 * Three actor cards (A&D, Advisor, Retail)
 * ALL content from Blueprint - NO hardcoded text or routes
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useBlueprint, BlueprintSection } from '../../context/BlueprintContext';
import { ArrowRight, Check } from 'lucide-react';

const EcosystemSection = () => {
  const { homepage, getRoute } = useBlueprint();
  const ecosystem = homepage?.ecosystem || {};
  const cards = ecosystem?.cards || [];
  
  // Resolve card links using config routes when possible
  const resolveLink = (link) => {
    // If link starts with /, it's a direct path
    if (link?.startsWith('/')) {
      return link;
    }
    // Otherwise try to get from routes
    return getRoute(link, '/');
  };
  
  return (
    <BlueprintSection name="ecosystem">
      <section className="bg-[var(--cream)] py-24">
        <div className="sr-container">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="sr-label mb-6">
              {ecosystem.label}
            </p>
            <h2 className="sr-title-section">
              {ecosystem.title}
            </h2>
          </div>
          
          {/* Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {cards.map((card, i) => (
              <div
                key={card.id || i}
                className="relative rounded-[14px] overflow-hidden min-h-[340px] cursor-pointer transition-transform duration-300 hover:-translate-y-1"
              >
                {/* Background Image */}
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url(${card.image})` }}
                />
                
                {/* Veil */}
                <div className="sr-eco-veil" />
                
                {/* Content */}
                <div className="relative z-10 p-8 w-[78%] h-full min-h-[340px] flex flex-col justify-between">
                  {/* Top */}
                  <div>
                    <h3 className="sr-title-role mb-2">
                      {card.role}
                    </h3>
                    <p className="text-[9px] font-bold tracking-[2.5px] text-[#CCC] uppercase">
                      {card.subtitle}
                    </p>
                  </div>
                  
                  {/* Bottom */}
                  <div>
                    {/* Features */}
                    <ul className="mb-7">
                      {(card.features || []).map((feature, j) => (
                        <li
                          key={j}
                          className="flex items-start gap-2.5 mb-2.5 text-[#EEE] text-sm leading-[1.5] font-medium"
                        >
                          <Check size={14} className="text-[var(--gold)] flex-shrink-0 mt-0.5" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    
                    {/* CTA */}
                    <Link
                      to={resolveLink(card.link)}
                      className="sr-btn-outline"
                    >
                      {card.cta}
                      <ArrowRight size={14} />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </BlueprintSection>
  );
};

export default EcosystemSection;
